import { render, staticRenderFns } from "./TaxTransfer.vue?vue&type=template&id=9c3113ba&scoped=true&"
import script from "./TaxTransfer.vue?vue&type=script&lang=js&"
export * from "./TaxTransfer.vue?vue&type=script&lang=js&"
import style0 from "./TaxTransfer.vue?vue&type=style&index=0&id=9c3113ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3113ba",
  null
  
)

export default component.exports